module.exports = __webpack_public_path__ + "img/hotspot rules fr.8e0b29fa.png";